import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";

interface RequireTermsProps {
  children: React.ReactNode;
}

const RequireTerms = ({ children }: RequireTermsProps) => {
  const { user, loading } = useAuth();
  const [termsAccepted, setTermsAccepted] = useState<boolean | null>(null);

  useEffect(() => {
    if (loading || !user) return;

    const checkTerms = async () => {
      const { data: profile } = await supabase
        .from("profiles")
        .select("terms_accepted_at")
        .eq("user_id", user.id)
        .single();

      setTermsAccepted(!!profile?.terms_accepted_at);
    };

    checkTerms();
  }, [user, loading]);

  if (loading || (user && termsAccepted === null)) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-muted-foreground">Se încarcă...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!termsAccepted) {
    return <Navigate to="/accept-terms" replace />;
  }

  return <>{children}</>;
};

export default RequireTerms;
